// Mock supply-chain company list. Shared by SupplyChain (listing) and
// SupplyChainManage pages so both surfaces stay in sync until we wire the
// real backend.

export const FLAG = {
  US: "🇺🇸", GB: "🇬🇧", DE: "🇩🇪", FR: "🇫🇷", JP: "🇯🇵",
  NL: "🇳🇱", CA: "🇨🇦", AU: "🇦🇺", IN: "🇮🇳", SG: "🇸🇬",
  ES: "🇪🇸", IT: "🇮🇹", BR: "🇧🇷", MX: "🇲🇽", TR: "🇹🇷",
};

export const COUNTRY_OPTIONS = [
  { code: "US", label: "United States" },
  { code: "GB", label: "United Kingdom" },
  { code: "DE", label: "Germany" },
  { code: "FR", label: "France" },
  { code: "NL", label: "Netherlands" },
  { code: "ES", label: "Spain" },
  { code: "IT", label: "Italy" },
  { code: "CA", label: "Canada" },
  { code: "AU", label: "Australia" },
  { code: "JP", label: "Japan" },
  { code: "SG", label: "Singapore" },
  { code: "IN", label: "India" },
  { code: "BR", label: "Brazil" },
  { code: "MX", label: "Mexico" },
  { code: "TR", label: "Turkey" },
];

export const SIZE_OPTIONS = [
  "1 – 10",
  "11 – 50",
  "51 – 200",
  "201 – 500",
  "501 – 1,000",
  "1,001 – 5,000",
  "5,001 – 10,000",
  "10,001+",
];

export const INDUSTRY_OPTIONS = [
  "Software & SaaS",
  "Payment Services",
  "Security Solutions",
  "CI/CD Solution",
  "Other",
];

export const MOCK_COMPANIES = [
  { domain: "stripe-platform.io", name: "Stripe Platform", sighting: "1 day", identity: 100, malware: { v: 100, d: "01/11/2026" }, breach: { v: 89, d: "01/10/2026" }, phish: { v: 23, d: "12/22/2025" }, combo: { v: 67, d: "01/09/2026" }, size: "10,001+", country: "US", trend: null, added: "08/01/2025" },
  { domain: "networkdefensegateway.com", name: "Network Defense Gateway", sighting: "1 day", identity: 100, malware: { v: 100, d: "01/11/2026" }, breach: { v: 100, d: "01/11/2026" }, phish: { v: 100, d: "01/10/2026" }, combo: { v: 100, d: "01/09/2026" }, size: "10,001+", country: "US", trend: null, added: "08/05/2025" },
  { domain: "twiliomsg-core.io", name: "Twilio Msg Core", sighting: "1 day", identity: 85, malware: { v: 100, d: "01/11/2026" }, breach: { v: 84, d: "01/10/2026" }, phish: { v: 45, d: "01/10/2026" }, combo: { v: 49, d: "01/09/2026" }, size: "10,001+", country: "US", trend: null, added: "08/10/2025" },
  { domain: "revenuecyclesuite.com", name: "Revenue Cycle Suite", sighting: "1 day", identity: 79, malware: { v: 100, d: "01/11/2026" }, breach: { v: 67, d: "01/10/2026" }, phish: { v: 15, d: "01/10/2026" }, combo: { v: 40, d: "08/19/2026" }, size: "10,001+", country: "US", trend: null, added: "09/02/2025" },
  { domain: "datadogcore-monitoring.com", name: "Datadog Core Monitoring", sighting: "3 days", identity: 76, malware: { v: 100, d: "01/08/2026" }, breach: { v: 77, d: "01/10/2026" }, phish: { v: 100, d: "01/10/2026" }, combo: { v: 47, d: "01/09/2026" }, size: "10,001+", country: "US", trend: null, added: "09/15/2025" },
  { domain: "lablogsystemcore.com", name: "Lab Log System Core", sighting: "3 days", identity: 63, malware: { v: 100, d: "12/14/2025" }, breach: { v: 66, d: "01/10/2026" }, phish: { v: 13, d: "12/22/2025" }, combo: { v: 38, d: "01/09/2026" }, size: "10,001+", country: "US", trend: "down", added: "10/01/2025" },
  { domain: "telehealthbridge.io", name: "Telehealth Bridge Platform", sighting: "5 days", identity: 58, malware: { v: 100, d: "12/16/2025" }, breach: { v: 60, d: "01/08/2026" }, phish: { v: 7, d: "12/20/2025" }, combo: { v: 35, d: "08/19/2026" }, size: "10,001+", country: "US", trend: "down", added: "10/12/2025" },
  { domain: "primaryehr.com", name: "Primary EHR", sighting: "3 days", identity: 58, malware: { v: 100, d: "12/23/2025" }, breach: { v: 60, d: "01/10/2026" }, phish: { v: 1, d: "12/15/2025" }, combo: { v: 34, d: "08/19/2026" }, size: "10,001+", country: "US", trend: null, added: "10/20/2025" },
  { domain: "securemessaginghub.io", name: "Secure Messaging Hub", sighting: "1 day", identity: 53, malware: { v: 93, d: "01/11/2026" }, breach: { v: 50, d: "01/11/2026" }, phish: { v: 100, d: "01/10/2026" }, combo: { v: 36, d: "08/19/2026" }, size: "10,001+", country: "US", trend: null, added: "11/03/2025" },
  { domain: "patientportalconnect.com", name: "Patient Portal Connect", sighting: "5 days", identity: 44, malware: { v: 52, d: "12/30/2025" }, breach: { v: 44, d: "01/08/2026" }, phish: { v: 3, d: "09/29/2025" }, combo: { v: 44, d: "08/19/2026" }, size: "1,001 – 5,000", country: "DE", trend: "down", added: "11/14/2025" },
  { domain: "cloudaccess-bridge.io", name: "Cloud Access Bridge", sighting: "1 week", identity: 41, malware: { v: 60, d: "12/05/2025" }, breach: { v: 38, d: "01/02/2026" }, phish: { v: 12, d: "12/18/2025" }, combo: { v: 28, d: "08/15/2026" }, size: "501 – 1,000", country: "GB", trend: null, added: "11/25/2025" },
  { domain: "vendoridentityhub.com", name: "Vendor Identity Hub", sighting: "2 days", identity: 38, malware: { v: 55, d: "01/05/2026" }, breach: { v: 34, d: "01/03/2026" }, phish: { v: 8, d: "12/29/2025" }, combo: { v: 22, d: "08/01/2026" }, size: "201 – 500", country: "FR", trend: null, added: "12/02/2025" },
  { domain: "supplychain-edi.io", name: "Supply Chain EDI", sighting: "4 days", identity: 32, malware: { v: 41, d: "12/28/2025" }, breach: { v: 30, d: "12/29/2025" }, phish: { v: 5, d: "12/10/2025" }, combo: { v: 19, d: "07/22/2026" }, size: "1,001 – 5,000", country: "NL", trend: "up", added: "12/18/2025" },
  { domain: "regulatoryreport.io", name: "Regulatory Report", sighting: "1 week", identity: 22, malware: { v: 30, d: "12/02/2025" }, breach: { v: 20, d: "12/20/2025" }, phish: { v: 2, d: "11/30/2025" }, combo: { v: 12, d: "07/01/2026" }, size: "51 – 200", country: "JP", trend: null, added: "01/05/2026" },
  { domain: "vendorrisk-saas.com", name: "Vendor Risk SaaS", sighting: "2 weeks", identity: 14, malware: { v: 21, d: "11/20/2025" }, breach: { v: 12, d: "12/10/2025" }, phish: { v: 1, d: "11/15/2025" }, combo: { v: 8, d: "06/15/2026" }, size: "11 – 50", country: "CA", trend: null, added: "01/15/2026" },
];

const STORAGE_KEY = "wi.supplyChainCompanies";

export function loadCompanies() {
  if (typeof window === "undefined") return MOCK_COMPANIES;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return MOCK_COMPANIES;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return MOCK_COMPANIES;
    return parsed;
  } catch {
    return MOCK_COMPANIES;
  }
}

export function saveCompanies(rows) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(rows));
  } catch {
    /* ignore */
  }
}
